import { useState } from "react";
import "../../assets/css/feed-card-item.css";
import FeedCardMSC from "./FeedCardMSC";
import FeedCaption from "./FeedCaption";
import Video from "../Video/Video";
import {
  mapSectorData,
  highlightFirstPhrase,
  normalizeCategoryKey,
  getFeedTitle
} from "../../helpers/helpers";
import { yearOnlyFormatTest } from "../../helpers/dateHelpers";
import { AnimatedLetter } from "../AnimatedGraphics/AnimatedLetter";
import { handleLetterClick } from "../../helpers/analyticsHelpers";
import { LazyLoadImage, LazyLoadComponent } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

export function FeedCardItem(props) {
  const [DLData, setDLData] = useState({});
  const { itemData, index } = props;
  const { type, data, actor, isNew } = itemData;
  const { title, body } = data;
  const [actorType] = actor.split(":");
  const threshold = 200;
  const feedText = getFeedTitle(itemData);
  const feedCardClass = isNew ? "" : "";

  // id, className, title, icon, dateText, datetime, children

  switch (type) {
    case "Photo":
      return (
        <FeedCardMSC
          index={index}
          className={feedCardClass}
          isNew={isNew}
          icon="photo"
          iconAlt="photo icon"
          id={`photo-${index}-${actorType}`}
          title={feedText.title}
          cardData={{ ...data, type }}
        >
          {feedText.subTitle ? <div>{feedText.subTitle}</div> : null }
          <LazyLoadImage key={`img-${index}`} effect="blur" src={body.url} alt={title} threshold={threshold} />
          <p className="card-caption">
            <FeedCaption caption={body.caption} type={actorType} />
          </p>
        </FeedCardMSC>
      );
    case "Video":
      return (
        <FeedCardMSC
          index={index}
          className={feedCardClass}
          isNew={isNew}
          icon="video"
          iconAlt="video icon"
          id={`video-${index}-${actorType}`}
          title={feedText.title}
          cardData={{ ...data, type }}
        >
          {feedText.subTitle ? <div>{feedText.subTitle}</div> : null }
          <LazyLoadComponent effect="blur" threshold={threshold}>
            <Video className="video-card" url={body.url} />
          </LazyLoadComponent>
          <p className="card-caption">
            <FeedCaption caption={body.caption} type={actorType} />
          </p>
        </FeedCardMSC>
      );

    case "Letter":
      return (
        <FeedCardMSC
          index={index}
          className={feedCardClass}
          isNew={isNew}
          icon="letter"
          iconAlt="letter icon"
          id={`letter-${index}-${actorType}`}
          title={feedText.title}
          cardData={{ ...data, type }}
          setDLData={setDLData}
        >
          {feedText.subTitle ? <div>{feedText.subTitle}</div> : null }
          <a
            href={data.body.url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() =>
              handleLetterClick({ ...DLData, click_text: "View letter" })
            }
          >
            <AnimatedLetter />
          </a>
          {data?.body?.caption ? (
            <p className="card-caption">{data.body.caption}</p>
          ) : null}
          <a
            href={data.body.url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() =>
              handleLetterClick({ ...DLData, click_text: "View letter" })
            }
          >
            View letter (pdf)
          </a>
        </FeedCardMSC>
      );

    case "Prayer Request":
      if (!body?.items) {
        return null;
      }

      return (
        <FeedCardMSC
          index={index}
          className={feedCardClass}
          isNew={isNew}
          icon="prayer"
          iconAlt="prayer icon"
          id={`prayer-${index}-${actorType}`}
          title={title}
          cardData={{ ...data, type }}
        >
          {body.items.map((item, key) => (
            <p className="card-request" key={key}>
              {item}
            </p>
          ))}
        </FeedCardMSC>
      );

    case "Accomplishment":
      if (!data?.subTitle || !data?.body?.items) {
        return null;
      }

      const sectorData = mapSectorData(data.subTitle);

      const accomplishmentData = data.body.items.map((accomplishment, key) => {
        const sentenceStructure = highlightFirstPhrase(2, 3, accomplishment);
        return (
          <li className="card-list-item" key={key}>
            <span className="card-content-highlighted">
              {sentenceStructure.highlightedPhrase}
            </span>{" "}
            {sentenceStructure.remainingSentence}
          </li>
        );
      });

      return (
        <FeedCardMSC
          index={index}
          className={feedCardClass}
          isNew={isNew}
          icon={normalizeCategoryKey(data.subTitle)}
          iconAlt={data.subTitle}
          id={`accomplishment-${index}-${actorType}`}
          title={sectorData.title}
          cardData={{ ...data, type, displayTime: yearOnlyFormatTest(data.displayTime) }}
        >
          <p className="card-overlay-text eta">{sectorData.text}</p>

          <ul className="card-list">{accomplishmentData}</ul>

          <p className="card-disclaimer">The impact shown above reflects the difference your support has made between January and December of the previous year. This update captures the most recent full year of progress in the community.</p>
        </FeedCardMSC>
      );
    default:
      return null;
  }
}

export default FeedCardItem;

/*

Date Example:
{
    "id": "aadkdad-fd3343-32432wsdlkjdf-qwref",
    "cardId": "r34985-dsfsde-324ssr0-sfeewwe",
    "type": "Video",
    "data": {
        "triggeringEvent": "child-update-video",
        "contentUrl": "https://damjoied8te1b.cloudfront.net/child/images/217568-PVPS_20220622_122845_CGP.jpg",
        "contentThumbUrl": "https://damjoied8te1b.cloudfront.net/child/images/217568-PVPS_20220622_122845_CGP_thumb.jpg",
        "contentDateTimeUtc": "2022-05-17T22:53:00Z",
        "title": "New Video for Davison",
        "caption": "Video caption"
    },
    "actor": "child:0a67f9a3-887e-411f-8b4b-6bf0f9b96f72",
    "verb": "Post",
    "target": "donor:2345678",
    "createTime": "2015-12-25T00:00:00"
}

{
    "id": "aadkdad-fd3343-32432wsdlkjdf-qwref",
    "cardId": "r34985-dsfsde-324ssr0-sfeewwe",
    "type": "Photo",
    "data": {
        "triggeringEvent": "child-update-photo",
        "contentUrl": "https://as01.epimg.net/en/imagenes/2020/10/19/other_sports/1603098643_725745_1603109932_noticia_normal_recorte1.jpg",
        "contentThumbUrl": "https://as01.epimg.net/en/imagenes/2020/10/19/other_sports/1603098643_725745_1603109932_noticia_normal_recorte1.jpg",
        "contentDateTimeUtc": "2022-05-17T22:53:00Z",
        "title": "New Photo for Davison",
        "caption": "Photo caption"
    },
    "actor": "child:0a67f9a3-887e-411f-8b4b-6bf0f9b96f72",
    "verb": "Post",
    "target": "donor:2345678",
    "createTime": "2015-12-25T00:00:00"
}

*/